import React from 'react';
import '../styles/Team.css';

function Team() {
  return (
    <div className="team">
      <div className="team-text">
        <div className="section-title">
          <h2>El Equipo</h2>
        </div>
        <p>Ariane con más de 4 años de experiencia en este sector no deja de esforzarse con cada cliente para que cada resultado sea único y especial. Trabaja día a día por crear un ambiente cómodo y relajante para que los clientes puedan disfrutar de su experiencia al máximo.</p>
      </div>
      <div className="team-image">
        <img src="/images/team.webp" alt="Ariane, fundadora de Ari Lashes" />
      </div>
    </div>
  );
}

export default Team;